import reducer from "./reducer";
export { default as MyOnboardingTracking } from "./components/index";
export { default as myOnboardingTrackingReducerName } from "./constants";
export default reducer;
